import inIframe from './inIframe';

export default inIframe;
